import { Link } from "react-router-dom";
import FormatePrice from '../utils/FormatePrice';
import { RiArrowRightSLine } from "react-icons/ri";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, ArcElement, Tooltip, Legend, ChartDataLabels);

const Piechart = ({transaction}) => {
  
  const data = {
    labels: '',
    datasets: [{
      // label: ["Failed Transactions", "Successful Transactions"],
      data: [transaction?.failePercemtageCount, transaction?.successPercentageCount],
      backgroundColor: [
        'rgba(176, 216, 176, 1)',
        'rgba(0, 128, 0, 1)',
      ],
      hoverOffset: 4
    }]
  }

  const options = {
    plugins: {
      datalabels: {
        color: "#fff",
        font: {
          size: 30,
          weight: "bold"
        },
        formatter: (value) => {
          return `${value}%`;
        }
      },
      tooltip: {
        enabled: true,
      }
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-5 items-center">
      <div>
        <h3 className="font-bold text-xl pb-2.5 px-5">Total Transactions</h3>
        <div className="w-[280px] h-[280px] mx-auto md:mx-0">
          <Pie data={data} options={options} />
        </div>
      </div>
      <div className="flex flex-row md:flex-col justify-between gap-10 md:gap-5 pt-8 md:pt-0">
        <div className=" flex flex-col border text-sm p-2 rounded-sm gap-2 bg-[#FCFCFC] border-[#E7E7E7]">
          <div className="flex items-center">
            <div className="h-4 w-4 bg-[#008000] rounded-sm" />
            <p className="pl-2 text-xs">Successful Transaction</p>
          </div>
          <div className="flex items-center">
            <div className="h-4 w-4 bg-[#B0D8B0] rounded-sm" />
            <p className="pl-2 text-xs">Failed Transaction</p>
          </div>
        </div>
        <div className="flex flex-col border text-sm p-2 gap-2 rounded-sm md:mt-12 bg-[#FCFCFC] border-[#E7E7E7]">
          <div className="flex items-center">
            <div className="h-4 w-4 bg-[#008000] rounded-sm" />
            <p className="pl-2 text-xs">{FormatePrice(transaction?.successAmount)}</p>
          </div>
          <div className="flex items-center">
            <div className="h-4 w-4 bg-[#B0D8B0] rounded-sm" />
            <p className="pl-2 text-xs">{FormatePrice(transaction?.successAmount)}</p>
          </div>
        </div>
        <Link to='/transaction' className="flex items-center justify-center py-3 hidden md:flex hover:text-primaryRed">
          <p className="text-sm">View All Orders</p>
          <RiArrowRightSLine className="ml-1 text-lg" />
        </Link>
      </div>
      <Link to='/transaction' className="flex items-center justify-center py-5 md:hidden hover:text-primaryRed">
        <p className="text-sm">View All Orders</p>
        <RiArrowRightSLine className="ml-1 text-lg" />
      </Link>
    </div>
  )
};

export default Piechart;